import { Button } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import Typography from 'helpers/fonts';
import React, { useState } from 'react';

export const ExpandableParagraph: React.FunctionComponent<{ text: string }> = ({
  text,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const textStyle = {
    margin: '0 0',
    fontWeight: 400,
    color: Theme['@grey-dark'],
    fontFamily: 'Gibson Book',
    fontSize: '12px',
    letterSpacing: '0.02em',
    lineHeight: '18px',
  };

  return (
    <>
      {expanded ? (
        <span style={{ display: 'flex' }}>
          <Paragraph
            style={{ margin: 0, lineHeight: '18px' }}
          >
            <Typography styleid={6} style={textStyle}>
              {text}
            </Typography>
            <Button
              onClick={() => setExpanded(false)}
              type="link"
              style={{
                fontSize: '12px',
                margin: '0 4px',
                padding: 0,
                height: '12px',
                border: 'none',
              }}
            >
              Close
            </Button>
          </Paragraph>
        </span>
      ) : (
        <Paragraph
          style={textStyle}
          ellipsis={{
            rows: 2,
            expandable: true,
            onExpand: () => {
              setExpanded(true);
            },
          }}
        >
          {text}
        </Paragraph>
      )}
    </>
  );
};
